import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from 'Pods/Shared/Icon/Icon'

function CancelUploadingModal({
  modalIsOpen, modalText, closeModal, terminateUploading,
}) {
  return (
    <Modal
      isOpen={modalIsOpen}
      shouldCloseOnOverlayClick
      onRequestClose={closeModal}
      contentLabel="Modal"
      ariaHideApp={false}
      className={{
        base: '',
        afterOpen: 'overlay-modal--container_after-open overlay-modal-container--smaller',
        beforeClose: 'overlay-modal--container_before-close',
      }}
      overlayClassName={{
        base: 'overlay-modal--background',
        afterOpen: 'overlay-modal--background_after-open',
        beforeClose: 'overlay-modal--background_before-close',
      }}
    >
      <div className="overlay-modal">
        <button className="btn btn-transparent overlay-modal--close-inner" onClick={closeModal}>
          <Icon type={['fal', 'times']} color="grey-dark" />
        </button>
        <div className="overlay-modal--content overlay-modal--cancel-uploading">
          <div className="l-inner-large">
            <h2 className="content-heading__h2 text-semibold text-warning">
              <Icon type={['far', 'exclamation-circle']} />Attention!
            </h2>
            <p className="text-dark">{modalText}</p>
            <div className="u-text-right">
              <button className="btn btn-outline-default btn-fat u-mt10 u-mr10" onClick={terminateUploading}>
                Terminate uploading
              </button>
              <button className="btn btn-primary btn-fat u-mt10" onClick={closeModal}>
                Continue uploading
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

CancelUploadingModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  modalText: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  terminateUploading: PropTypes.func.isRequired,
}

export default CancelUploadingModal
